<template>
<div>
  <div class="container p-px-6 p-pt-6 p-pb-3 p-shadow-1 ">
    
    <div class="p-field p-grid">
      <label for="firstname" class="p-col-fixed" style="width:100px">E-post</label>
      <div class="p-col">
          <InputText type="text" v-model="authInput.email" @keyup.enter.native="submit" />
      </div>
    </div>
    <div class="p-field p-grid">
        <label for="lastname" class="p-col-fixed" style="width:100px">Passord</label>
        <div class="p-col">
            <Password v-model="authInput.password" :feedback="false" @keyup.enter.native="submit" />
        </div>
    </div>
    <div class="p-field p-grid">
        <div class="p-col p-d-flex p-jc-end">
            <Button label="Login" @click="submit" />
        </div>
    </div>
  </div>
  <Message v-if="missingPremission" severity="info" :closable="false">Kontakt Glør for å få tilgang</Message>
  <Message v-if="error" severity="error" :closable="false">Ugyldig e-post eller passord</Message>
  <div class="p-d-flex p-jc-center p-mt-6">
    <img src="@/assets/logo.png" width="200px"/>
  </div>
</div>
</template>

<script>


import { auth } from '@/firebase/db'
import Password from 'primevue/password';
import Message from 'primevue/message';

export default {
  name: 'login',
  components: {
    Password,
    Message
  },
  data() {
    return {
      authInput: {
        email: '',
        password: ''
      },
      error: false,
      missingPremission: false
    }
  },
  mounted(){
    if(typeof this.$route.query.hasPremissions !== 'undefined')
      this.missingPremission = true
  },
  methods: {
    submit() {
      this.error = false 
      
      auth
        .signInWithEmailAndPassword(this.authInput.email, this.authInput.password)
        .then(() => {
          this.$router.replace({ name: "dashboard" });
        })
        .catch(() => {
          this.error = true
        });
    }
  }
}
</script>

<style scoped>
.container{
  background-color: white
}
</style>
